import React from 'react'
import { useSelector } from 'react-redux'
import { i18nContext as context } from './context'

const InternationalizationProvider = ({children}) => {
  const translation = useSelector(state => state.translation.data)
  const translationMicrosite = useSelector(state => state.translation.data_microsite)
  const language = useSelector(state => state.system.language)

  const translate = (category, key) => {
    const result = translation[category]?.[key]?.[language.name]
    return result ? result : key
  }

  const translateMicrosite = (category, key) => {
    return translationMicrosite[category][key][language.name]
  }

  return (
    <context.Provider value={{
      translate,
      translateMicrosite,
      translation,
      language
     }}>
      {children}
    </context.Provider>
  )
}

export { InternationalizationProvider }
